import React from "react";
import Form from "./common/Form";
import Joi from "joi-browser";

class RegisterForm extends Form {
  state = {
    data: { userName: "", password: "", name: "" },
    errors: {}
  };

  schema = {
    userName: Joi.string().required().email().label("Username"),
    password: Joi.string().required().min(6).label("Password"),
    name: Joi.string().required().label("Name")
  };

  doSubmit = () => {
    // clear the server
    console.log("fomt submitted");
  };

  render() {
    return (
      <div>
        <h1>Register</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("userName", "Username")}
          {this.renderInput("password", "Password", "password")}
          {this.renderInput("name", "Name")}
          {this.renderBtn("Register")}
        </form>
      </div>
    );
  }
}

export default RegisterForm;
